import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { FormControl } from '@angular/forms';
import { MatSnackBar, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-record-table',
  templateUrl: './record-table.component.html',
  styleUrls: ['./record-table.component.css']
})
export class RecordTableComponent implements OnInit, OnChanges {
  @Input() data = new MatTableDataSource();
  @Input() index: number;
  @Input() displayedColumns: string[];
  @Input() headerTxt: string[];
  @Input() pageSizeOptions: number[];
  @Input() selectedDates: string[] = [];
  @Input() downloading = false;
  @Input() downloadErr = false;
  @Output() recs: EventEmitter<any> = new EventEmitter();
  @Output() dates: EventEmitter<any> = new EventEmitter();
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  expandedRow: any | null;
  selection = new SelectionModel(true, []);
  startDate = new FormControl();
  endDate = new FormControl();
  options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalseparator: '.',
    showLabels: false,
    headers: [],
    showTitle: false,
    title: '',
    useBom: false,
    removeNewLines: true,
    keys: []
  };

  constructor(public dialog: MatDialog, private sbar: MatSnackBar) { }

  ngOnInit() {

    if (this.selectedDates.length > 0) {
      const drange = this.selectedDates[this.selectedDates.length - 1];

      const beginDate = new Date(drange[0]);
      const endDate = new  Date(drange[1]);
      beginDate.setDate(beginDate.getDate() + 1);
      endDate.setDate(endDate.getDate() + 1);

      this.startDate.setValue(beginDate);
      this.endDate.setValue(endDate);
    }
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.downloadErr && this.downloadErr) {
      const vert: MatSnackBarVerticalPosition = 'top';

      this.sbar.open('A download Error occurred. Please click the Search button again.', '', {
        duration: 4000,
        verticalPosition: vert
      });

      this.downloadErr = false;
    }

    if (this.data) {
      this.data.paginator = this.paginator;
      this.data.sort = this.sort;

    }

    if (this.headerTxt) {
      this.options.headers = this.headerTxt;
    }

    if (this.displayedColumns) {
      this.options.keys = this.displayedColumns;
    }
  }

  click() {
    const dt: Date[] = [];

    dt.push(this.startDate.value);
    dt.push(this.endDate.value);

    const ret = {
      tab: this.index,
      dates: dt
    };

    this.dates.emit(ret);
  }

  openDialog(event): void {
    const d = this.data.sortData(this.data.data, this.sort);
    const i = d.findIndex(n => n['id'] === event);
    const config: MatDialogConfig = new MatDialogConfig();
    config.data = {
      index: i,
      tabIndex: this.index,
      data: d
    };

    config.width =  '70%';
    config.height = '90%';

    const dialogRef = this.dialog.open(DialogComponent, config);

    dialogRef.afterClosed().subscribe(res => {

      if (res) {
        this.changes(res);
      } else {
        this.changes(this.data.data);
      }
    });
  }

  changes(data: any[]) {
    const ret = [];

    data.forEach(n => {
      if (n.Exclude) {
        n.UpdateList.push('exclude');
        ret.push(n);
      }
      if (n.UserData.Note.dirty) {
        n.UpdateList.push('note');

        const i = n.UserData.Note.get('Selected').value;
        const stat = n.NoteProfile.DropdownEntries.filter(n => n.value === i);

        if (stat.length > 0) {
          n.Status = stat[0].text;
        }

        ret.push(n);
        n.UserData.Note.markAsPristine();
      }
    });

    if (ret.length > 0) {
      this.recs.emit({
        data: ret,
        index: this.index
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.data.filter = filterValue.trim().toLowerCase();

    if (this.data.paginator) {
      this.data.paginator.firstPage();
    }
  }

  isAllSelected() {
    if (this.data) {
      const numSelected = this.selection.selected.length;
      const numRows = this.data.data.length;
      return numSelected === numRows;
    }
  }

  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.data.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }

    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.Id}`;
  }
}
